import type { IdentityTypeKey } from "../types/public";

const normalizeIdentity = (value?: string) =>
  (value || "").replace(/[-\s]+/g, "").toUpperCase();

const isValidIdentity = (value?: string) => {
  const clean = normalizeIdentity(value);
  if (!clean) return false;

  // MyKad: exactly 12 digits
  if (/^\d{12}$/.test(clean)) return true;

  // Passport: 7 to 20 alphanumeric characters
  return /^[A-Z0-9]{7,20}$/.test(clean);
};

const getIdentityType = (value?: string): IdentityTypeKey | null => {
  const clean = normalizeIdentity(value);

  if (!clean) return null;

  if (/^\d{12}$/.test(clean)) {
    return "NRIC";
  }

  if (/^[A-Z0-9]{7,20}$/.test(clean)) {
    return "PASSPORT";
  }

  return null;
};

export { normalizeIdentity, isValidIdentity, getIdentityType };
